import React from 'react';
import { Row, Col } from 'react-bootstrap';

import home from '../../img/home.svg';
import money from '../../img/money.svg';
import time from '../../img/time.svg';
import case1 from '../../img/case.svg';


const ServiceProviderCard = () => {
  return (
    <section className="my-5">
      <div className="service-provider-card">
        <div className="d-flex align-items-start gap-4 mb-4">
          <div className="provider-icon-wrapper">
            <img src={home} alt="Provider icon" />
          </div>
          <div className="flex-grow-1">
            <h2 className="provider-title">Надавач послуги:</h2>
            <hr className="dashed-divider-inner" />
            <p className="provider-name">Департаменту освіти і науки КМДА</p>
          </div>
        </div>
        
        <Row className="gx-3">
          <Col lg={4}>
            <div className="info-item">
              <div className="mb-2">
                <h6 className="info-item-title mb-1">Вартість</h6>
                <hr className="dashed-divider-inner" />
              </div>
              <div className="d-flex align-items-center">
                <div className="info-icon-wrapper me-3">
                  <img src={money} alt="Cost icon" />
                </div>
                <p className="mb-0">Безкоштовно</p>
              </div>
            </div>
          </Col>
          
          <Col lg={4}>
            <div className="info-item">
              <div className="mb-2">
                <h6 className="info-item-title mb-1">Термін подання</h6>
                <hr className="dashed-divider-inner" />
              </div>
              <div className="d-flex align-items-center">
                <div className="info-icon-wrapper me-3">
                  <img src={time} alt="Time icon" />
                </div>
                <p className="mb-0">До 31 серпня</p>
              </div>
            </div>
          </Col>
          
          <Col lg={4}>
            <div className="info-item">
              <div className="mb-2">
                <h6 className="info-item-title mb-1">Розсилання запрошень</h6>
                <hr className="dashed-divider-inner" />
              </div>
              <div className="d-flex align-items-center">
                <div className="info-icon-wrapper me-3">
                  <img src={case1} alt="Case icon" />
                </div>
                <p className="mb-0">З 1 квітня</p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ServiceProviderCard;